/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { DisputeSuccessMessage } from '../../../components/disputeSuccessMessage/DisputeSuccessMessage';
import { LoadingSpinner } from '../../../components/loadingSpinner/loadingspinner';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import { IDispute } from '../../../utils/types';
import { AddFormDispute } from '../addFormDispute/AddFormDispute';
import { transformDataAddDisputeForm } from '../data-adapter';
import '../dispute.scss';
import { useCreateDisputeMutation } from '../disputeSlice';

type propsAddDispute = {
    disputeDialogEnable: boolean;
    closeAllDisputes: (message: boolean) => void;
    selectedMetric: any;
    employeeNo: number;
};

export const AddDispute = ({
    disputeDialogEnable,
    closeAllDisputes,
    selectedMetric,
    employeeNo,
}: propsAddDispute) => {
    const [CreateDispute] = useCreateDisputeMutation();
    const [disputeDialog, setDisputeDialog] = useState(false);
    const [addDisputeEmpty, setAddDisputeEmpty] = useState(false);
    const [errorMessage, setErrorMessage] = useState<any>();
    const [isLoading, setPageLoading] = useState(false);
    const [disableSave, setDisableSave] = useState<boolean>(true);
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [formFields, setFormFields] = useState<any>([]);

    useEffect(() => {
        if (selectedMetric?.length > 0) {
            setDisputeDialog(disputeDialogEnable);
            const disputes: IDispute[] = transformDataAddDisputeForm(
                selectedMetric,
                loggedEmpNum?.toString(),
                employeeNo?.toString()
            );
            setFormFields(disputes);
            setDisableSave(false);
        }
    }, [selectedMetric]);

    useEffect(() => {
        if (formFields.length <= 0) {
            setDisableSave(true);
            setErrorMessage('');
        } else {
            validateForm();
            if (errorMessage === '') setDisableSave(false);
            else setDisableSave(true);
        }
    }, [errorMessage, formFields]);

    const handleFormChange = (event: any, index: number) => {
        const data = [...formFields];
        data[index][event.target.name] = event.target.value;
        setFormFields(data);
    };

    const saveMetricDisputeClicked = () => {
        let disputeList: IDispute[] = [];
        disputeList = formFields;
        const isformValid = validateForm();

        if (!isformValid) {
            console.log('No Error');
        } else {
            setDisableSave(true);
            setPageLoading(true);
            setErrorMessage('');
            createMetricDispute(disputeList);
        }
    };

    const validateForm = (): boolean => {
        let disputeList: IDispute[] = [];
        disputeList = formFields;
        setErrorMessage('');
        for (let i = 0; i < disputeList.length; i++) {
            const dispute: IDispute = disputeList[i];
            if (dispute.disputeReasonid === 0) {
                setErrorMessage('Please select Dispute reason');
                return false;
            }
            if (dispute.disputeComment === '') {
                setErrorMessage('Please enter Dispute comment.');
                return false;
            }
            const disputedValue = dispute.disputedValue?.toString().replace(/[^a-zA-Z0/.00-9/.99 ]/g, '');
            const proposedValue = dispute.proposedValue?.toString().replace(/[^a-zA-Z0/.00-9/.99 ]/g, '');

            if (disputedValue && proposedValue === disputedValue) {
                setErrorMessage('Expected Value and Disputed value should not be same.');
                return false;
            }
        }
        return true;
    };

    const createMetricDispute = (disputes: any) => {
        const data = {
            disputes,
        };
        CreateDispute(data)
            .unwrap()
            .then(() => {
                setAddDisputeEmpty(true);
                setPageLoading(false);
                setDisableSave(true);
            })
            .then((error: any) => {
                if (error) console.log(error);
                setDisableSave(true);
            });
    };

    const disputeModalHeader = () => {
        return (
            <div>
                <h5 className="pe-3">
                    <span style={{ fontSize: '16px', fontWeight: 700 }} className="pt-2">
                        Add Dispute
                    </span>
                </h5>

                <span className="error-text" id="errMessage">
                    {errorMessage}
                </span>
            </div>
        );
    };

    const disputeModalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <Button
                    disabled={disableSave}
                    className="btn-primary w-auto float-end"
                    onClick={saveMetricDisputeClicked}
                >
                    Save Changes
                </Button>
                <Button
                    className="btn-secondary float-end"
                    onClick={hideDisputeDialog}
                >
                    Cancel
                </Button>
                <span>{isLoading ? <LoadingSpinner /> : ''}</span>
            </React.Fragment>
        );
    };

    const dialogFuncMap = {
        disputeDialog: setDisputeDialog,
    };

    const hideDisputeDialog = () => {
        dialogFuncMap.disputeDialog(false);
        closeAllDisputes(false);
    };

    const removeDispute = (index: number) => {
        const data = [...formFields];
        data.splice(index, 1);
        setFormFields(data);
    };

    return (
        <Dialog
            visible={disputeDialog}
            style={{ width: '50vw' }}
            header={!addDisputeEmpty ? disputeModalHeader : ''}
            modal
            className="p-fluid disputeModal"
            onHide={hideDisputeDialog}
            footer={!addDisputeEmpty ? disputeModalFooter : ''}
            closable={false}
        >
            <>
                {addDisputeEmpty && (
                    <DisputeSuccessMessage successMsg="Submitted" closeAllDisputes={closeAllDisputes} />
                )}

                {!addDisputeEmpty && (
                    <div className="row">
                        {formFields?.map((dispute: any, index: number) => {
                            return (
                                <React.Fragment key={dispute.disputeId}>
                                    <AddFormDispute
                                        dispute={dispute}
                                        index={index}
                                        handleFormChange={handleFormChange}
                                        removeDispute={removeDispute}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </>
        </Dialog>
    );
};
